import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ActionButton } from "../../../../../_metronic/_partials/controls/ActionButton";

// Validation schema
const OrganizationFileSchema = Yup.object().shape({
  caption: Yup.string().required("Nama Dokumen Wajib diisi!")
});

export function OrganizationFileEditForm({
  submit,
  show,
  onHide,
  loading,
  initialValues
}) {
  if (initialValues.organization_uuid) {
    Object.assign(OrganizationFileSchema, {
      file: Yup.mixed().required("File harus dipilih.")
    });
  }
  function updateFile(event, submit) {
    const { files } = event.target;

    if (files instanceof FileList) {
      submit(files[0]);
    }
  }
  return (
    <>
      <Modal show={show} onHide={onHide}>
        <Modal.Header>
          <Modal.Title>
            {initialValues.organization_uuid ? "Edit File" : "Tambah File"}
          </Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={OrganizationFileSchema}
          onSubmit={values => {
            submit(values, onHide);
          }}
        >
          {({ handleSubmit, values, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="form-group row">
                  <div className="col">
                    <label htmlFor="caption">Nama Dokumen</label>
                    <Field
                      name="caption"
                      className="form-control"
                      component="input"
                      value={values.caption}
                      onChange={e => setFieldValue("caption", e.target.value)}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col d-flex flex-column">
                    <label htmlFor="file">Dokumen</label>
                    <div className="input-group">
                      <div className="custom-file">
                        <input
                          name="file"
                          type="file"
                          className="custom-file-input"
                          // accept=".doc, .docx, .xls, .xlsx, .csv, .pdf"
                          id="project-document"
                          onChange={e =>
                            updateFile(e, value => setFieldValue("file", value))
                          }
                          disabled={values.organization_uuid}
                          readOnly={values.organization_uuid}
                        />
                        <label
                          className="custom-file-label"
                          htmlFor="project-document"
                        >
                          {values.file instanceof File
                            ? values.file.name
                            : "Choose file"}
                        </label>
                      </div>
                    </div>
                    <ErrorMessage
                      name="file"
                      render={msg => (
                        <span className="mt-2 text-danger">{msg}</span>
                      )}
                    />
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-secondary mr-3"
                    onClick={onHide}
                  >
                    Batal
                  </button>
                  <ActionButton type="submit" loading={loading} text="Simpan" />
                </div>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
